import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config';
import {
  FamilyApprovalTwoFAPersonCentricType,
  FamilyApprovalTwoFAType,
  KundanzuganHaushaltDetailResponse,
  KundanzuganHaushaltDetailType,
  KundanzuganQRTransactionStatusResponse,
  KundanzuganTransactionResponse,
  KundanzuganTransactionStatusResponse,
  KundanzuganTransactionStatusType,
  PersonCentricDetail,
} from 'type/twoFactor';
import { getApiClient } from './api-client';

export const familyApprovalTwoFaApi = () => {
  const baseURL = getEnvironmentApiUrls().registration;

  const api = getApiClient(baseURL);

  const addContext = false;
  const apiWithoutContext = getApiClient(baseURL, addContext);

  const sendFamilyApprovalTwoFA = async (
    payload: FamilyApprovalTwoFAType,
    signal?: AbortSignal,
  ) => {
    const { keycloakId, ...restParam } = payload;
    return api.post<string, FamilyApprovalTwoFAType>(
      `/rest/v1/dvag-pass/users/${keycloakId}/confirmation/familienfreigabe`,
      restParam,
      { signal },
    );
  };

  const sendFamilyApprovalTwoFAPersonCentric = async (
    payload: FamilyApprovalTwoFAPersonCentricType,
    signal?: AbortSignal,
  ) => {
    const { keycloakId, confirmation } = payload;
    return api.post<string, PersonCentricDetail[]>(
      `/rest/v2/dvag-pass/users/${keycloakId}/confirmation/familienfreigabe`,
      confirmation,
      { signal },
    );
  };

  const sendFamilyApprovalTwoFATransaction = async (
    payload: FamilyApprovalTwoFAPersonCentricType,
    signal?: AbortSignal,
  ) => {
    const { keycloakId, confirmation } = payload;
    return api.post<KundanzuganTransactionResponse, PersonCentricDetail[]>(
      `/rest/v1/transaction/users/${keycloakId}/confirmation/familienfreigabe`,
      confirmation,
      { signal },
    );
  };

  const kundanzuganTransactionStatusApi = async (
    payload: KundanzuganTransactionStatusType,
    signal?: AbortSignal,
  ) =>
    api.get<KundanzuganTransactionStatusResponse>(
      `/rest/v1/dvag-pass/transactions/${payload.transactionId}/status`,
      { signal },
    );

  const kundanzuganHaushaltDetailApi = async (
    payload: KundanzuganHaushaltDetailType,
    signal?: AbortSignal,
  ) =>
    apiWithoutContext.get<KundanzuganHaushaltDetailResponse[]>(
      `/rest/v1/webcomponent/vb/${payload.advisorId}/kunden/haushalt/${payload.householdId}/status/detail`,
      { signal },
    );

  const getKundanzuganTransactionStatus = async (pollingUrl: string, signal?: AbortSignal) =>
    api.get<KundanzuganQRTransactionStatusResponse>(pollingUrl, { signal });

  return {
    sendFamilyApprovalTwoFA,
    kundanzuganHaushaltDetailApi,
    kundanzuganTransactionStatusApi,
    sendFamilyApprovalTwoFAPersonCentric,
    sendFamilyApprovalTwoFATransaction,
    getKundanzuganTransactionStatus,
  };
};
